import React, { useState } from "react";
import { ChevronDown, Archive } from "lucide-react";

export const PastCourses = ({ count, testid, children }) => {
  const [open, setOpen] = useState(false);
  if (!count) return null;
  return (
    <section className="mt-6" data-testid={testid}>
      <button data-testid={`${testid}-toggle`} onClick={() => setOpen((o) => !o)}
        className="flex items-center gap-2 rounded-full px-4 py-2 text-sm font-semibold border bg-white hover:bg-[#F2F6F5]" style={{ borderColor: "var(--sj-border)", color: "var(--sj-text-2)" }}>
        <Archive className="h-4 w-4" /> Past courses ({count})
        <ChevronDown className="h-4 w-4 transition-transform" style={{ transform: open ? "rotate(180deg)" : "none" }} />
      </button>
      {open && <div className="mt-4 opacity-90">{children}</div>}
    </section>
  );
};
